<template>
  <div>
    <div class="current-position">
      <img class="common-banner2" src="../assets/img/banner.png" alt="">
      <div class="current-position-text">
        <div class="common-container">
          <div class="current-position-logotext">Matrix</div>
        </div>
        <div class="common-container">
          当前位置: 首页  >  {{ menu.title }} >  {{ menu.list[menu.list.findIndex( item => item.id == menu_id)].name }}
        </div>
      </div>
    </div>
    <div class="survey-module">
      <div class="common-container justify-between">
        <div class="survey-module-left">
          <div class="survey-module-left-action">
            <div class="survey-module-left-title justify-center align-center">{{ menu.title }}</div>
            <div class="survey-module-left-item" 
              v-for="(item,index) in menu.list" 
              :key="index" 
              :class="menu_id==item.id?'survey-module-left-item-select':''"  
              @click="menuFun(item.id)"
            >
              <div class="survey-module-left-child justify-center align-center">{{ item.name }}</div>
            </div>
          </div>
        </div>
        <div class="survey-module-right">
          <div class="survey-module-right-title f-w">
            {{ menu.list[menu.list.findIndex( item => item.id == menu_id)].name }}
          </div>
          <!-- 考试管理 -->
          <ksgl v-if="menu_id==1"/>
          <!-- 培训基地 -->
          <pxjd v-if="menu_id==2"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ksgl from '@/components/pxjdgl/ksgl.vue'
import pxjd from '@/components/pxjdgl/pxjd.vue'
export default {
  components:{
    ksgl,pxjd
  },
  data(){
    return{
      loading:false,
      menu:{
        title:'培训基地管理',
        list:[
          {name:'考试管理',id:'1'},
          // {name:'培训基地',id:'2'},
        ]
      },
      menu_id:this.$route.query.id,
    }
  },
  methods:{
    menuFun(id){
      this.menu_id = id
    },
  }
}
</script>
<style scoped lang="css" src="../assets/css/rem.css" />
<style>
.table-body .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #8fc930 !important;
  border-color: #8fc930 !important;
}
.table-body .el-checkbox__input.is-focus  .el-checkbox__inner{
  border-color: #8fc930 !important;
}
.table-body .el-checkbox__inner:hover{
  border-color: #8fc930 !important;
}
.table-body .el-button--text {
  color: #8fc930 !important;
}
.table-body .el-button--text:hover {
  color: #72b701 !important;
}
</style>
